import {
    ASSOCIATIONS_POST_FAILURE,
    ASSOCIATIONS_POST_REQUEST,
    ASSOCIATIONS_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const associationPostReducer = (state = initialState, action) => {
    const {type, association} = action;
    switch (type) {
        case ASSOCIATIONS_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            association,
        }}

        case ASSOCIATIONS_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case ASSOCIATIONS_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
